import { render, staticRenderFns } from "./TheGoBack.vue?vue&type=template&id=9109f0ec&"
import script from "./TheGoBack.vue?vue&type=script&lang=js&"
export * from "./TheGoBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports